module.exports = __webpack_public_path__ + "static/media/kingsley-pic.7dba0aff.jpeg";